<template>
  <a-modal
    v-model:open="open"
    :width="width"
    :title="!success ? title : ''"
    centered
    :mask-closable="true"
    :wrap-class-name="!success ? 'xmov-form-modal' : ''"
    @cancel="cancel"
  >
    <div v-if="!success">
      <div>
        {{
          $t(
            'zai-nin-ti-gong-xin-xi-wan-zheng-zheng-que-de-qian-ti-xia-cai-wu-yu-ji-zai-5-ge-gong-zuo-ri-nei-kai-ju-wan-bi-bing-fa-song-dao-nin-ti-gong-de-you-xiang-qing-nai-xin-deng-dai'
          )
        }}~
      </div>
      <div
        class="bg-back-3 rounded-[8px] p-[20px_16px] mt-[24px] flex flex-col gap-[15px]"
      >
        <div
          v-for="(item, index) in descList"
          :key="index"
          class="text-font-50 text-12 flex-y-center gap-[5px]"
        >
          <iconpark-icon name="star"></iconpark-icon>
          {{ item }}
        </div>
      </div>
    </div>
    <div v-if="success">
      <div class="flex flex-col items-center my-[70px]">
        <iconpark-icon
          name="circle-check"
          size="56"
          class="text-success"
        ></iconpark-icon>
        <div class="text-[20px] mt-[13px] font-medium">
          {{ $t('ti-jiao-cheng-gong') }}
        </div>
        <div class="text-[14px] text-font-80 mt-[40px] text-center w-[287px]">
          {{
            $t(
              'yu-ji-zai-5-ge-gong-zuo-ri-nei-kai-ju-wan-bi-bing-fa-song-dao-nin-ti-gong-de-you-xiang-qing-nai-xin-deng-dai'
            )
          }}
        </div>
      </div>
    </div>
    <template #footer>
      <template v-if="!success">
        <a-button @click="cancel">{{ $t('qu-xiao') }}</a-button>
        <a-button type="primary" @click="submit">
          {{ $t('ti-jiao-shen-qing') }}
        </a-button>
      </template>
    </template>
  </a-modal>
</template>

<script lang="ts" setup>
import { PageKey } from '~/constants/page'

const props = defineProps<{
  title: string
  width: number
  success: boolean
}>()

const open = ref(false)
const emits = defineEmits(['submit'])
const { $t } = useNuxtApp()

const descList = [
  $t(
    'dian-zi-fa-piao-yi-dan-kai-chu-jiang-bu-zhi-chi-geng-huan-fa-piao-qing-que-bao-nin-tian-xie-xin-xi-wu-wu'
  ),
  $t(
    'gen-ju-zhong-guo-shui-wu-bu-men-dui-fa-piao-guan-li-de-gui-ding-yao-qiu-kai-piao-shen-qing-ren-ti-gong-zhen-shi-de-kai-piao-xin-xi-fa-piao-tai-tou-bu-ke-sui-yi-tian-xie'
  ),
  $t(
    'zeng-zhi-shui-dian-zi-fa-piao-de-fa-lv-xiao-li-yu-shui-wu-ji-guan-jian-zhi-de-zeng-zhi-shui-zhi-zhi-fa-piao-xiao-li-xiang-tong'
  ),
]

const toggleShow = () => {
  open.value = !open.value
}

const submit = () => {
  emits('submit')
}

const cancel = () => {
  if (props.success) {
    const router = useRouter()
    router.push({
      name: PageKey.CENTER_ORDER,
    })
    open.value = false
  } else {
    open.value = false
  }
}

defineExpose({
  toggle: toggleShow,
})
</script>
